import styled from "@emotion/styled";

export const WelcomeText = styled.span`
  font-weight: 400;
  @media (max-width: 480px) {
    font-size: 48px;
  }
`;
